// Password validation rules and helper. Used by account activation and reset.

const PASSWORD_RULES = [
  { test: (v) => v.length >= 8, label: 'Mínimo 8 caracteres' },
  { test: (v) => /[A-Z]/.test(v), label: 'Una letra mayúscula' },
  { test: (v) => /[a-z]/.test(v), label: 'Una letra minúscula' },
  { test: (v) => /\d/.test(v), label: 'Un número' },
  { test: (v) => /[^A-Za-z0-9]/.test(v), label: 'Un carácter especial' },
];

/**
 * Validates a password against all rules.
 * @param {string} password
 * @returns {string|null} Error message listing the failing rules, or null if valid.
 */
export function validatePassword(password) {
  const failing = PASSWORD_RULES.filter((r) => !r.test(password));
  if (failing.length > 0) {
    return `La contraseña debe tener: ${failing.map((r) => r.label.toLowerCase()).join(', ')}`;
  }
  return null;
}
